import { render, staticRenderFns } from "./LabelWithTooltip.vue?vue&type=template&id=13fb16ec&scoped=true&"
import script from "./LabelWithTooltip.vue?vue&type=script&lang=js&"
export * from "./LabelWithTooltip.vue?vue&type=script&lang=js&"
import style0 from "./LabelWithTooltip.vue?vue&type=style&index=0&id=13fb16ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb16ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
